import { PersonType } from 'enums';
import { AddressData, initialAddress } from '../workflowPersonalDataStore/model';
import { Gender } from 'common/interfaces';

export interface CompanyOwner {
  id: string;
  firstname: string;
  lastname: string;
  relationship: string;
  address: AddressData;
  gender: Gender;
  birthDate: string;
  placeOfBirth: string;
  citizenship: string;
  taxResidency: string;
  taxNumber?: string;
  pepData: {
    politicallyExposedPerson: boolean;
    politicallyExposedDetail: string;
    document?: string;
  }
  document?: {
    pep?: string;
  }
}

export interface CompanyOwnersData {
  addingEnabled: boolean;
  owners: CompanyOwner[];
  options: { countryCode: string[]; ownerRelationship: string[] };
}

export interface AMLData {
  personType: PersonType;
  incomeType: {
    type: string;
    riskBranch: string;
    document?: string;
    thirdPersonType: string;
  };
  incomeInterval: string;
  revenueInterval: string;
  incomeSource: {
    type: string;
    amount: number;
    document?: string;
  };
  pepData: {
    politicallyExposedPerson: boolean;
    politicallyExposedDetail: string;
    document?: string;
  }
  otherRiskIssues: {
    exist: boolean;
    issues: string;
  };
  options: {
    incomeType: string[];
    incomeInterval: string[];
    incomeSource: string[];
    riskBranch: string[];
    revenueInterval: string[];
    fraudSuspicionReason: string[];
    incomeTypeDocRequired: string[];
    incomeSourceDocRequired: string[];
    thirdPersonIncomeType: string[];
  };
  fraudSuspicion: boolean;
  fundingRiskSuspicion: boolean;
  irrationalSelection: boolean;
  irrationalSelectionClient: string;
  irrationalSelectionActual: string;
  listedClient: boolean;
  notPresent: boolean;
  overLimit: boolean;
  riskTerritory: boolean;
  riskTerritoryAssociates: boolean;
  riskTerritoryOwner: boolean;
  thirdPersonSuspicion: boolean;
  unclearOrigin: boolean;
  unclearStructure: boolean;
  wayOfConduct: boolean;
  fraudSuspicionReasons: string[];
  fraudSuspicionDetail: string;

  companyOwners: CompanyOwner[]; // PDF
}

export const initialValuesCompanyOwner = {
  id: '',
  firstname: '',
  lastname: '',
  gender: Gender.NOT_CHOSEN,
  relationship: '',
  address: initialAddress,
  birthDate: '',
  placeOfBirth: '',
  citizenship: '',
  taxResidency: '',
  pepData: {
    politicallyExposedPerson: false,
    politicallyExposedDetail: '',
  }
};

export const initialValues = {
  incomeType: {
    type: '',
    riskBranch: '',
    thirdPersonType: ''
  },
  incomeInterval: '',
  revenueInterval: '',
  incomeSource: {
    type: '',
  },
  politicallyExposedPerson: false,
  fraudSuspicionReasons: ['', '', ''],
};
